import { getPercentDifference } from '@/fsd/shared/lib/helpers/getPercentDifference/getPercentDifference';
import { ReactNode } from 'react';
import { ITariffPricing } from '../../model/types/ITariffPricing';

interface IParams {
  tariffsPricing: ITariffPricing;
  tabContent: ({
    month,
    percentAmount,
  }: {
    month: string;
    percentAmount?: string;
  }) => ReactNode;
}

export const getSwitcherValue = ({ tariffsPricing, tabContent }: IParams) => {
  const switcherValue = [
    {
      id: 0,
      name: tabContent({
        month: '1 месяц',
      }),
    },
    {
      id: 2,
      name: tabContent({
        month: '6 месяцев',
        percentAmount: `${getPercentDifference(
          tariffsPricing.monthly,
          tariffsPricing.six_months
        )}`,
      }),
    },
    {
      id: 3,
      name: tabContent({
        month: '12 месяцев',
        percentAmount: `${getPercentDifference(
          tariffsPricing.monthly,
          tariffsPricing.twelve_months
        )}`,
      }),
    },
  ];

  return switcherValue;
};
